import { IScoreEditorThis } from "../../../../../common/types";

export const deselectNote = function (this: IScoreEditorThis) {
  this.setState({ selectedNote: null });
  this.scoreRef.removeEventListener("click", this.deselectNote, true);
  this.hasClickEventListener = false;
};
